// @ts-nocheck
import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import {
  LayoutDashboard,
  HelpCircle,
  FileText,
  PlusCircle,
  Calculator,
  ShieldCheck,
  Receipt,
  Archive,
  Users 
} from "lucide-react";

import logoSidebar from "../../assets/images/Real-Beneficios-logosidebar.png";

/**
 * @param {Object} props
 * @param {string} props.to
 * @param {any} props.icon
 * @param {string} props.text
 * @param {function} [props.onClick]
 * @param {boolean} [props.end]
 */
const NavItem = ({ to, icon: Icon, text, onClick, end = false }) => {
  return (
    <li>
      <NavLink
        to={to}
        end={end}
        onClick={onClick}
        className={({ isActive }) =>
          `group flex items-center justify-between px-3 py-2.5 mb-1 text-sm font-medium rounded-xl transition-all duration-300
          ${
            isActive
              ? "bg-brand-primary text-white shadow-md shadow-brand-primary/30"
              : "text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800/50 hover:text-brand-primary dark:hover:text-brand-primary"
          }`
        }
      >
        <div className="flex items-center truncate">
          <Icon className="h-5 w-5 flex-shrink-0 transition-colors duration-200" />
          <span className="ml-3 tracking-wide truncate">{text}</span>
        </div>
      </NavLink>
    </li>
  );
};

/**
 * @param {Object} props
 * @param {boolean} props.isSidebarOpen
 * @param {function} [props.onToggleSidebar]
 */
const ClientSidebar = ({ isSidebarOpen, onToggleSidebar }) => {
  const { userInfo } = useAuth();

  if (!userInfo) return null;

  const handleItemClick = () => {
    if (window.innerWidth < 1024 && onToggleSidebar) {
      onToggleSidebar();
    }
  };

  return (
    <>
      {/* Overlay para Mobile */}
      {isSidebarOpen && (
        <div
          onClick={onToggleSidebar}
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 lg:hidden transition-opacity"
          aria-hidden="true"
        ></div>
      )}

      <aside
        className={`fixed top-0 left-0 z-50 w-64 h-screen flex flex-col 
        bg-white dark:bg-slate-900 border-r border-slate-200/60 dark:border-slate-700/60
        transition-transform duration-300 ease-in-out lg:translate-x-0 lg:sticky lg:top-0 lg:h-screen lg:z-20 shrink-0 ${
          isSidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"
        }`}
      >
        {/* Cabeçalho - Identidade Real Benefícios */}
        <div className="h-[72px] flex items-center justify-start px-6 border-b border-slate-200/60 dark:border-slate-700/60 shrink-0 bg-white dark:bg-slate-900 overflow-hidden">
          <img 
            src={logoSidebar} 
            alt="Real Benefícios" 
            className="h-10 sm:h-12 w-auto object-contain transition-all duration-300 drop-shadow-sm scale-150 origin-left ml-4"
          />
        </div>

        {/* Navegação Principal */}
        <nav className="flex-1 p-4 overflow-y-auto custom-scrollbar">
          <ul className="space-y-1">
            
            <div className="px-3 pt-4 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Principal
            </div>
            
            <NavItem
              to="/dashboard"
              icon={LayoutDashboard}
              text="Visão Geral"
              onClick={handleItemClick}
              end
            />
            
            <NavItem
              to="/dashboard/carteira"
              icon={ShieldCheck}
              text="Minha Carteira"
              onClick={handleItemClick}
            />

            <NavItem
              to="/dashboard/historico"
              icon={Archive}
              text="Histórico de Locações"
              onClick={handleItemClick}
            />

            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Financeiro
            </div>
            
            <NavItem
              to="/dashboard/faturas"
              icon={Receipt}
              text="Faturas e Repasses"
              onClick={handleItemClick}
            />

            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Operação
            </div>
            
            <NavItem
              to="/dashboard/novo-request"
              icon={PlusCircle}
              text="Nova Solicitação"
              onClick={handleItemClick}
            />
            
            <NavItem
              to="/dashboard/requests"
              icon={FileText}
              text="Solicitações"
              onClick={handleItemClick}
            />

            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Ferramentas
            </div>
            
            <NavItem
              to="/dashboard/simulador"
              icon={Calculator}
              text="Simulador"
              onClick={handleItemClick}
            />

            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Configurações
            </div>

            <NavItem
              to="/dashboard/testemunhas"
              icon={Users}
              text="Testemunhas (Contratos)"
              onClick={handleItemClick}
            />

            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
              Suporte
            </div>
            
            <NavItem
              to="/dashboard/ajuda"
              icon={HelpCircle}
              text="Ajuda & Suporte"
              onClick={handleItemClick}
            />

          </ul>
        </nav>
      </aside>
    </>
  );
};

export default ClientSidebar;